import axios from 'axios';
import {AppConfig} from '@/config/AppConfig';

// import {AppConfig} from '../config/AppConfig';

// axios.defaults.headers.common['Accept'] = "application/json"  
// axios.defaults.headers.common['x-client-id'] = "gongcha"
// axios.defaults.headers.common['x-secret-key'] = "AAAA"

let headers = {
  
    'Accept':'application/json',
    'x-client-id':'gongcha',
    'x-secret-key':'AAAA',
}

const API_PREFIX = '/app/api/v1'

// const requestPost = (method,url,data) => {
//   // return new Promise((resolve,reject) => {

//     let full_url = process.env.VUE_APP_API_DOMAIN + API_PREFIX + url;
//     // let full_url = 'http://115.68.226.95:10080/mytom/api/login'
//     console.log(`Axios.request => method:${method},url:${full_url}`);  
//     console.log('Axios.request => headers',axios.defaults.headers.common)
//     if(data)console.log(`Axios.request => data:${JSON.stringify(data)}`);
//     console.log(data);

//     // console.log('axios =>',axios.defaults);
    
//       return axios ({ 
//         method: method, 
//         url: full_url, 
//         data,

//         // headers:headers
//       })  
//     .then(result => {
//       console.log(`Axios.requestPost => result:${JSON.stringify(result)}`);    
//       return result.data
//       // resolve(result.data)
//     }) 
//     .catch(err => { 
//       console.log('Axios.requestPost -> catch');
//       console.log(err);
//       // console.log(axios.defaults);
//       console.error(`Axios.requestPost => error : ${JSON.stringify(err)}`);
//         // const {status} = result.response 
//         // if (status === UNAUTHORIZED) 
//         // return onUnauthroized() 
//         // throw Error(result) 
//         throw err;
//         // reject(err)
//     }) 
//   // })
// }

const requestPost =  (method,url,data) => {
  return new Promise(async (resolve,reject) => {

    // let full_url = process.env.VUE_APP_API_DOMAIN + API_PREFIX + url;
    let full_url = AppConfig.VUE_APP_API_DOMAIN + API_PREFIX + url;
    if(data)console.log(`Axios.requestPost => method:${method},url:${full_url},data:${JSON.stringify(data)}`);
    
      return axios ({ 
        method: method, 
        url: full_url, 
        data,
        timeout:5000,
        headers:headers
      })  
    .then(result => {
      console.log(`Axios.requestPost => result:${JSON.stringify(result)}`);    
      resolve(result.data)
    }) 
    .catch(err => { 
      console.log(`Axios.requestPost.catch => error : ${JSON.stringify(err)}`);
      // console.error(`Axios.requestPost.catch => error : ${JSON.stringify(err)}`);        
      // throw err
      // const {status} = result.response 
      // if (status === UNAUTHORIZED) 
      //   return onUnauthroized() 

      reject(err)
    }) 
  })
}


const requestGet = (method,url,params) => {

  return new Promise(async (resolve,reject) => {
    let full_url = AppConfig.VUE_APP_API_DOMAIN + API_PREFIX + url;
    // let full_url = process.env.VUE_APP_API_DOMAIN + API_PREFIX + url;
    // let full_url = 'http://115.68.226.95:10080/mytom/api/login'
    // console.log(`Axios.requestGet => method:${method},url:${full_url}`);    
    if(params)console.log(`Axios.requestGet => method:${method},url:${full_url}, params:${JSON.stringify(params)}`);

      return axios ({ 
        method: method, 
        url: full_url, 
        params:params,
        timeout:5000,
        headers:headers
      })  
    .then(result => {
      console.log(`Axios.requestGet => result:${JSON.stringify(result)}`);    
      // return result.data
      resolve(result.data)
    }) 
    .catch(err => { 
      console.log(`Axios.requestGet.catch => error : ${JSON.stringify(err)}`);
      // console.error(`Axios.requestGet.catch => error : ${JSON.stringify(err)}`);    
      reject(err)  
    }) 
  })
}

//
export const Axios = {
  
  get(url,params){
    return requestGet('get',url,params);
  }
  ,post(url,data){
    return requestPost('post',url,data);
  },
  setAccessToken(token){
    axios.defaults.headers.common['Authorization'] = token ? `Bearer ${token}` : null;
  },
  removeAccessToken(){
    console.log('Axios.removeAccessToken');
    // delete axios.defaults.headers.common["Authorization"];
    delete headers.Authorization;
  },
  interceptors(){
    return axios.interceptors;
  }
  
}
//set header token
var Authorization;
export const setAuthToken = token => {  
  // console.log('Axios.setAuthToken => ' ,token);
  // Authorization = `Bearer ${token}`
  headers.Authorization = `Bearer ${token}`
  // axios.defaults.headers.common['Authorization'] = token ? `Bearer ${token}` : null;
}



// WEBPACK FOOTER //
// ./src/api/Axios.js